module.exports = __webpack_public_path__ + "static/img/homeleft21.8c33636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft21.png
// module id = oT1X
// module chunks = 13